import { CommonModule } from "@angular/common";
import { Component } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatInputModule } from "@angular/material/input";
import { RouterModule } from "@angular/router";
import { KeycloakService } from "keycloak-angular";
import { environment } from "src/environments/environment";
import { UnleashService } from "../../services/unleash.service";
import { Observable } from "rxjs";

@Component({
  selector: "myqq-unauth-footer",
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    RouterModule,
    ReactiveFormsModule,
    MatInputModule,
  ],
  templateUrl: "./unauth-footer.component.html",
  styleUrl: "./unauth-footer.component.scss",
})
export class UnauthFooterComponent {
  constructor(
    readonly keycloakSvc: KeycloakService,
    private readonly unleashService: UnleashService
  ) {}
  readonly enableFriendBuy$: Observable<boolean> = this.unleashService
    .enableFriendBuy$;

  cdnHost = environment.cdnHost;
  contactUsLink = "https://www.dontdrivedirty.com/contactus/";
  aboutQQLink = "/about-qq";
  charitableGivingLink = "https://www.dontdrivedirty.com/charitable-giving/";
  newsroomLink = "https://www.dontdrivedirty.com/newsroom/";
  sustainabilityLink = "https://www.dontdrivedirty.com/sustainability/";
  privacyPolicyLink = "/privacy-policy";
  termsOfUseLink = "/terms-of-use";
  termsOfServiceLink = "/terms-of-service";
  commercialLink = "https://www.dontdrivedirty.com/commercial-accounts/";
  newLocationsLink =
    "https://www.dontdrivedirty.com/new-coming-locations-of-2023/";
}
